import script from "./TradePassportInsurance.vue?vue&type=script&lang=ts&setup=true"
export * from "./TradePassportInsurance.vue?vue&type=script&lang=ts&setup=true"

import "./TradePassportInsurance.vue?vue&type=style&index=0&id=b1257a12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1257a12"]])

export default __exports__